export const TOASTER_MESSAGE = {
  APPLICATON_DELETED: 'Application deleted',
  APPLICATION_DRAFTED: 'Application drafted',
  APPLICATION_SUBMITTED: 'Application submitted',
  APPLICATION_UPDATED: 'Application updated',
  APPLICATION_APPROVED: 'Application approved',
  APPLICATION_ACCEPTED: 'Application accepted',
  OBLIGATION_PAYMENT_SAVED: 'Obligation payment details saved',
  OBLIGATION_PAYMENT_UPDATED: 'Obligation payment details updated',
  APPLICATON_DECLARATION_AUTHORISE: 'Application authorised',
  APPLICATON_DECLARATION_SUBMITTED: 'Application submitted',
  OBLIGATION_CREDIT_PRICE_UPDATED: 'Obligation credit price details updated',
  OBLIGATION_DELETED: 'Obligation has been deleted successfully.',
  SUCCESS: '${MESSAGE} successfully',
  DELETE_SUCCESS: '${MESSAGE} deleted successfully',
  DRAFTED_SUCCESS: '${MESSAGE} drafted successfully',
  PROGRAM_CREATED: 'Program created',
  PROGRAM_UPDATED: 'Program updated',
  PROGRAM_APPROVED: 'Program approved',
  COMMENT_ADDED: 'Comment added',
  COMMENT_UPDATED: 'Comment updated',
  DOWNLOAD_WARNING: 'Data not available',
  PURCHASE_RECORD_CREATED: 'Purchase record created',
  PURCHASE_RECORD_UPDATED: 'Purchase record updated',
  CREDIT_REFERENCE_CREATED: 'Credit Reference Created',
  CREDIT_REFERENCE_UPDATED: 'Credit Reference Updated',
  CREDIT_RETIREMENT_CREATED: 'Credit Retirement Created',
  CREDIT_RETIREMENT_UPDATED: 'Credit Retirement Updated',
  USER_UPDATED: 'User Updated',
  OBLIGATION_RULE_UPDATED: 'Obligation Rule Updated',
  OBLIGATION_ACQUITTAL_CREATED: 'Obligation Aquittal Created',
  OBLIGATION_ACQUITTAL_UPDATED: 'Obligation Aquittal Updated',

  EMAIL_TEMPLATE_CREATED: 'Email created',
  EMAIL_TEMPLATE_UPDATED: 'Email updated',
  EMAIL_TEMPLATE_DELETED: 'Email deleted'
}
